import type { TrackingDriver } from '@/tracking/contracts/TrackingDriver'
import type { TrackingEvent, TrackingEventPayload } from '@/tracking/types/TrackingEvent.ts'

export class MockTrackingDriver implements TrackingDriver {

  async start(): Promise<void> {
    console.debug('Starting tracking')
  }

  async send<T extends TrackingEvent>(
    event: T,
    payload: TrackingEventPayload[T],
  ): Promise<void> {
    console.debug(`Tracking: "${event}"}, payload: `, payload)
  }

  ready(): Promise<this> {
    return new Promise((resolve) => resolve(this))
  }
}